import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import InputField from "../../ui/form/InputField";
import isValidPercentage from "../../validators/percentage";

const ElementPercentageField = ({ element, onChange, ...rest }) => {

    const [className, setClassName] = useState("percentage")

    const handleChange = (e) => {
        element.percentage = e.target.value;
        setClassName(isValidPercentage(element.percentage) ? "percentage" : "percentage invalid");
        onChange(element);
    };

    return (
        <>
            <InputField
                onChange={handleChange}
                value={element.percentage}
                className={className}
                min="0"
                max="100"
                type="number"
                {...rest}
            /> %
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ElementPercentageField));